import React from 'react';

import { DEFAULT_TEMPLATE, DEFAULT_TIMEZONE } from '../constants';
import { useDateFormat } from '../hooks/useDateFormat';
import { IDateRangeFormatter } from '../interfaces';

const Wrapper = ({ children }: any) => {
  return <span style={{ whiteSpace: 'nowrap' }}>{children}</span>;
};

export const DateRangeFormatter = ({
  value = [],
  timeZone = DEFAULT_TIMEZONE,
  template = DEFAULT_TEMPLATE,
}: IDateRangeFormatter) => {
  const dateFormat = useDateFormat({ timeZone, template });

  const range = dateFormat(value);
  if (range[0] === range[1]) {
    return <Wrapper>{range[0]}</Wrapper>;
  } else {
    return (
      <span style={{ display: 'inline-block' }}>
        <span style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Wrapper>{range[0]}&nbsp;-&nbsp;</Wrapper>
          {range[1] && <Wrapper>{range[1]}</Wrapper>}
        </span>
      </span>
    );
  }
};
